/**
 * Feature toggles that must default to DISABLED (unchecked) in the role editor
 * when a role has no saved value for them yet — the opposite of the usual
 * "default enabled". Opt-in features go here so they stay off until an admin
 * explicitly turns them on.
 */
export const DEFAULT_DISABLED_FEATURES: string[] = [
    // Picker app ENTRY defaults OFF: a role must be explicitly granted picker
    // access. (The per-section picker-*-access toggles intentionally default ON
    // so a granted picker sees all sections unless one is explicitly turned off.)
    'picker-app-access',
    // POS app ENTRY defaults OFF: a role must be explicitly granted POS access
    // (the app reads pos-app-access with a strict === true check).
    'pos-app-access'
];

/** Default visibility for a feature id when it is absent from the saved settings map. */
export const defaultFeatureVisible = (id: string): boolean => !DEFAULT_DISABLED_FEATURES.includes(id);
